import React, { useEffect, useRef, useState } from "react";
import "./mobile_navbar.scss";
import Hamburger from "hamburger-react";
import { useLocation } from "react-router";
import { gsap } from "gsap";

const MobileNavbar = ({ mobileRef }) => {
  const location = useLocation().pathname;
  const [page, setPage] = useState("");
  const [isOpen, setOpen] = useState(false);
  const menuRef = useRef();
  const currentPageRef = useRef();
  const allNavRef = useRef();

  useEffect(() => {
    console.log(location);

    if (location === "/") {
      setPage("HOME");
    } else if (location === "/projects" || location.startsWith("/projects")) {
      setPage("PROJECTS");
    } else if (location === "/contact") {
      setPage("CONTACT");
    } else {
      setPage("NOT FOUND");
    }
  }, []);

  useEffect(() => {}, [page]);

  useEffect(() => {
    if (isOpen) {
      gsap.to(currentPageRef.current, {
        opacity: 0,
        ease: "power1.inOut",
        duration: 0.5,
      });
      gsap.to(allNavRef.current, {
        opacity: 1,
        ease: "power1.inOut",
        duration: 0.8,
      });
      gsap.to(menuRef.current, {
        height: "125px",
        duration: 1,
        ease: "power2.inOut",
      });
    } else {
      gsap.to(allNavRef.current, {
        opacity: 0,
        ease: "power1.inOut",
        duration: 0.2,
      });
      gsap.to(currentPageRef.current, {
        opacity: 1,
        ease: "power1.inOut",
        duration: 0.3,
      });

      gsap.to(menuRef.current, {
        height: "50px",
        duration: 1,
        ease: "power2.inOut",
      });
    }
  }, [isOpen]);

  return (
    <div className="mobile_navbar_main" ref={mobileRef}>
      <div className="mobile_navbar_container">
        <div className="page_name" ref={menuRef}>
          <p ref={currentPageRef}>{page}</p>
          <div className="all_nav_mobile" ref={allNavRef}>
            <a
              href="/"
              className={`${location === "/" ? "selected_page" : ""}`}
            >
              HOME
            </a>
            <a
              href="/projects"
              className={`${location === "/projects" ? "selected_page" : ""}`}
            >
              PROJECTS
            </a>
            <a
              href="/contact"
              className={`${location === "/contact" ? "selected_page" : ""}`}
            >
              CONTACT
            </a>
          </div>
        </div>
        <div className="mobile_navbar_icon">
          <Hamburger size={25} toggled={isOpen} toggle={setOpen} />
        </div>
      </div>
    </div>
  );
};

export default MobileNavbar;
